import { render, staticRenderFns } from "./log.vue?vue&type=template&id=c48581f0&scoped=true"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48581f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\dm\\longda\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48581f0')) {
      api.createRecord('c48581f0', component.options)
    } else {
      api.reload('c48581f0', component.options)
    }
    module.hot.accept("./log.vue?vue&type=template&id=c48581f0&scoped=true", function () {
      api.rerender('c48581f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/center/log.vue"
export default component.exports